<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'branch/index' }">
                                Cabang
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            List Cabang
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="col-auto" v-if="roleElligibleModified()">
                <router-link v-bind:to="{ name: 'branch/add' }" class="btn btn-danger btn-sm font-weight-medium mt-4 mb-2 px-5">
                    Create New Cabang +
                </router-link>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <h3>Cabang Utama</h3>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12" v-for="(branch, index) in primaryBranches" v-bind:key="branch.id">
                <branch-item-view v-bind:branch="branch" v-bind:index="index" v-on:confirm="confirmation"></branch-item-view>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <h3>Cabang Mitra</h3>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12" v-for="(branch, index) in branches" v-bind:key="branch.id">
                <branch-item-view v-bind:branch="branch" v-bind:index="index" v-on:confirm="confirmation"></branch-item-view>
            </div>
        </div>

        <b-modal v-model="modalShow" v-on:hide="removeReference = null" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin mau menghapus cabang ini? Karena jika sudah terhapus data tidak dapat dikembalikan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="remove">
                            Ya
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modalShow = false">
                            Batal
                        </button>
                    </div>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import BranchItem from "@/components/branch/item/Branch";
    import { mapState } from 'vuex';

    export default {
        name: "BranchIndex",
        components: {
            "branch-item-view": BranchItem
        },
        computed: mapState([
            'profile'
        ]),
        data() {
            return {
                modalShow: false,
                removeReference: null,
                branches: [{}, {}, {}, {}, {}, {}],
                primaryBranches: [{}, {}, {}, {}, {}, {}]
            };
        },
        methods: {
            confirmation(model) {
                this.modalShow = true;
                this.removeReference = model;
            },
            remove() {
                if (this.removeReference) {
                    this.axios.post(process.env.API_URL + '/branch/delete/' + this.removeReference.id).then(response => {
                        if (response.data.status) {
                            this.$toastr('success', response.data.message, 'Success');
                            this.fetchBanner();
                        } else {
                            this.$toastr('warning', 'Gagal menghapus cabang', 'Warning');
                        }
                        this.modalShow = false;
                        this.removeReference = null;
                    });
                }
            },
            fetchBanner() {
                this.axios.get(process.env.API_URL + '/branch').then(response => {
                    var data = response.data.data;
                    this.branches = data.filter(branch => {
                        return !branch.isPrimary;
                    });
                    this.primaryBranches = data.filter(branch => {
                        return branch.isPrimary;
                    });
                });
            },
            roleElligibleModified() {
                return this.profile.isAdmin;
            }
        },
        created() {
            this.fetchBanner();
        },
        mounted(){
            document.title = 'List Branch - ' + process.env.APP_NAME;
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/branch/Index.vue